<template>
    <v-container>
        <v-layout justify-center row pa-5 mt-12>
            <qrcode-vue :value="url" :size="size" level="H"></qrcode-vue>
<!--            <p class="mt-4">{{ url }}</p>-->
        </v-layout>
        <v-layout justify-center row pa-5 mt-12>
            <v-btn block
                   color="#0d47a1"
                   dark
                   @click="copyLink(url)">
                Copy Link
            </v-btn>
        </v-layout>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">copy สำเร็จ</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="dialog = false">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import axios from '@/axios';
    import EventBus from '@/EventBus'
    import QrcodeVue from 'qrcode.vue'
    import copy from 'copy-to-clipboard';

    export default {
        name      : "GenLinkParcel",
        components: {
            QrcodeVue,
        },
        data() {
            return {
                url : 'https://mobileapps.lpn.co.th/parcel/#/ot-parcel/' + this.getLocalItem().nt_runno + '/0',
                size: 250,
                dialog:false
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'สร้าง link สำหรับลูกค้า', back_route: 'ot-parcel-emp'});

            let localItem = this.getLocalItem();
        },
        methods   : {
            copyLink(value) {
                if(value){
                    this.dialog = true
                    copy(value);
                }
            },
        }
    }
</script>

<style scoped>

</style>
